import { useCurrentCustomerQuery } from "~/queries/finance/customers";

// This composables manages logic to handle shipping location for matchwornshirt
// When the A/B test is completed, we can merge this with useEstimatedUserShippingAddress
const _useShippingLocation = () => {
  const { isLoggedIn } = useAuth();
  const storedShippingLocation = useStorageSafely({
    type: "localStorage",
    key: "shippingLocation",
    defaultValue: "",
  });

  const showSignedOutCostsDirect = useGrowthbook({
    feature: "signed-out-bid-costs",
    fallback: false,
    enabled: () => !isLoggedIn.value,
  });

  const { data: customer } = useCurrentCustomerQuery();

  const customerDefaultShippingAddress = computed(() =>
    customer.value?.addresses.find((a) => a.isShippingAddress),
  );

  const shippingLocation = computed(() => {
    if (customerDefaultShippingAddress.value) {
      return customerDefaultShippingAddress.value.countryCode;
    } else if (!showSignedOutCostsDirect.result.value) {
      return storedShippingLocation.value;
    }

    return storedShippingLocation.value.length
      ? storedShippingLocation.value
      : getEstimatedUserCountry();
  });

  return {
    shippingLocation,
    isShippingLocationConfirmed: computed(() => {
      return !!(shippingLocation.value && shippingLocation.value.length > 0);
    }),
    setShippingLocation: (countryCode: string) => {
      storedShippingLocation.value = countryCode;
    },
  };
};

export default createSharedComposable(_useShippingLocation);
